import { useState } from "react";
import { useAuth } from "../Context/AuthContext";
import API from "../Context/api";
import ErrorMessage from "../Helpers/ErrorMessage";

function AddReceiptForm({ setIsModalOpen, onReceiptUpdated }) {
  const [customer, setCustomer] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [chequeNo, setChequeNo] = useState("");
  const [balance, setBalance] = useState("");
  const [amountInWords, setAmountInWords] = useState("");
  const [paymentfor, setPaymentfor] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { user } = useAuth();
  const createdBy = user ? user.name : "";

  const saveReceipt = async () => {
    if (
      !customer.trim() ||
      !totalAmount ||
      !amountInWords.trim() ||
      !paymentfor.trim()
    ) {
      alert(
        "Please add a customer name, total amount, amount in words, and payment for."
      );
      return;
    }

    const receiptData = {
      customer: { client: customer },
      receiptHeader: {
        companyName: "KEVMARK INVESTMENTS LTD",
        companyTIN: "1000135996",
        address:
          "Plot 59 Nkrumah-Nasser Link Plaza Nsooba, P.O. Box 71341 Kampala",
        phone: "0752 / 0772-551",
        email: ["kevmark2000@gmail.com", "sales@kevmarkinvestments.com"],
        description:
          "Stationary, Scholastic Materials, Toners, Computers, Computer Hardware and Software Maintenance",
      },
      receiptDetails: {
        date: new Date().toISOString().slice(0, 10),
        totalAmount: parseFloat(totalAmount),
        chequeNo,
        balance: parseFloat(balance || 0),
        amountInWords,
        paymentfor,
      },
      createdBy,
    };

    try {
      setIsLoading(true);
      await API.post("/receipts", receiptData); // Send to SharePoint endpoint
      setCustomer("");
      setTotalAmount("");
      setChequeNo("");
      setBalance("");
      setAmountInWords("");
      setPaymentfor("");
      onReceiptUpdated();
      setIsModalOpen(false);
    } catch (error) {
      console.error("Error saving receipt to SharePoint:", error);
      setErrorMessage(
        `Failed to save receipt: ${error.message || "Unknown error"}`
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 z-50">
      <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100 flex flex-col h-[90vh] sm:h-[80vh]">
        {/* Header */}
        <div className="p-4 border-b">
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-800">
            Add New Receipt
          </h2>
          <ErrorMessage message={errorMessage} />
        </div>
        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto px-4 py-2 space-y-4">
          {/* Customer Name and Receipt Inputs */}

          <label
            className="block text-gray-700 text-sm mb-2"
            htmlFor="customer-name"
          >
            Customer Name
          </label>
          <input
            id="customer-name"
            type="text"
            className="border border-gray-300 p-2 rounded w-full mb-2"
            placeholder="Customer Name"
            value={customer}
            onChange={(e) => setCustomer(e.target.value)}
          />
          <label
            className="block text-gray-700 text-sm mb-2"
            htmlFor="paymentfor"
          >
            Being Payment For
          </label>
          <input
            id="paymentfor"
            type="text"
            className="border border-gray-300 p-2 rounded w-full mb-2"
            placeholder="Being Payment For"
            value={paymentfor}
            onChange={(e) => setPaymentfor(e.target.value)}
          />

          <label
            className="block text-gray-700 text-sm mb-2"
            htmlFor="total-amount"
          >
            Total Amount (UGX)
          </label>
          <input
            id="total-amount"
            type="number"
            className="border border-gray-300 p-2 rounded w-full mb-2"
            placeholder="Total Amount (UGX)"
            value={totalAmount}
            onChange={(e) => setTotalAmount(e.target.value)}
          />

          <label
            className="block text-gray-700 text-sm mb-2"
            htmlFor="amountInWords"
          >
            Amount In Words
          </label>
          <input
            type="text"
            id="amountInWords"
            className="border border-gray-300 p-2 rounded w-full my-2"
            placeholder="Amount in words"
            value={amountInWords}
            onChange={(e) => setAmountInWords(e.target.value)}
          />

          <label
            className="block text-gray-700 text-sm mb-2"
            htmlFor="cheque-no"
          >
            Cheque No (optional)
          </label>
          <input
            id="cheque-no"
            type="text"
            className="border border-gray-300 p-2 rounded w-full mb-2"
            placeholder="Cheque No (optional)"
            value={chequeNo}
            onChange={(e) => setChequeNo(e.target.value)}
          />

          <label className="block text-gray-700 text-sm mb-2" htmlFor="balance">
            Balance (UGX, optional)
          </label>
          <input
            id="balance"
            type="number"
            className="border border-gray-300 p-2 rounded w-full mb-2"
            placeholder="Balance (UGX, optional)"
            value={balance}
            onChange={(e) => setBalance(e.target.value)}
          />
          {/* Grand Total */}
          <div className="mt-4 text-right text-lg font-semibold">
            Total: UGX{" "}
            {totalAmount ? parseFloat(totalAmount).toLocaleString() : "0"}
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="p-4 border-t flex flex-col sm:flex-row justify-end gap-2">
          {/* Buttons */}
          <div className="mt-4 flex justify-end space-x-2">
            <button
              onClick={saveReceipt}
              disabled={isLoading}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto ${
                isLoading
                  ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                  : "bg-blue-500 text-white hover:bg-blue-600"
              }`}
            >
              {isLoading ? "Submitting..." : "Submit"}
            </button>
            <button
              onClick={() => setIsModalOpen(false)}
              className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddReceiptForm;
